/* ============================================================
   TIPI POP — Scroll Reveal & Interactive Enhancements
   No commerce logic. No add-to-cart, checkout, or form interference.
   Safe to remove by deleting the script tag in layout/theme.liquid.
   ============================================================ */

(function () {
  'use strict';

  // --- Scroll Reveal with IntersectionObserver ---
  var revealObserver = null;

  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tipi-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -80px 0px'
    });

    // Add reveal classes to key sections
    var revealSelectors = [
      '.tipi-home__statement',
      '.tipi-home__process',
      '.tipi-home__closer',
      '.tipi-collection__bar',
      '.tipi-collection__grid',
      '.tipi-product__story',
      '.tipi-product__features',
      '.tipi-product__faq',
      '.tipi-growth-layer'
    ];

    revealSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.classList.add('tipi-reveal');
        revealObserver.observe(el);
      });
    });

    // Card grid — stagger reveal
    var grids = document.querySelectorAll('.tipi-home__grid, .tipi-collection__grid');
    grids.forEach(function (grid) {
      grid.classList.add('tipi-reveal-scale');
      revealObserver.observe(grid);
    });

    // Individual cards — stagger
    var cardGrids = document.querySelectorAll('.tipi-home__grid');
    cardGrids.forEach(function (grid) {
      var cards = grid.querySelectorAll('.tipi-home__card');
      cards.forEach(function (card, i) {
        card.style.transitionDelay = (i * 0.08) + 's';
      });
    });
  }

  // --- Add marquee banner after hero ---
  function addMarquee() {
    var hero = document.querySelector('.tipi-home__hero');
    if (!hero) return;

    // Check if marquee already exists
    if (document.querySelector('.tipi-marquee')) return;

    var marquee = document.createElement('div');
    marquee.className = 'tipi-marquee';
    marquee.setAttribute('aria-hidden', 'true');

    var track = document.createElement('div');
    track.className = 'tipi-marquee__track';

    var phrases = [
      'Custom Metal Prints',
      'Personalized Engravings',
      'Custom Apparel',
      'Drinkware',
      'One-of-One Gifts',
      '3D Printing',
      'Made in Texas'
    ];

    // Duplicate phrases for seamless loop
    var html = '';
    for (var rep = 0; rep < 2; rep++) {
      phrases.forEach(function (phrase) {
        html += '<span>' + phrase + '</span>';
      });
    }
    track.innerHTML = html;
    marquee.appendChild(track);

    // Insert after hero, before statement
    hero.parentNode.insertBefore(marquee, hero.nextSibling);
  }

  // --- Header scroll behavior — shrink/glow on scroll ---
  function initHeaderScroll() {
    var header = document.querySelector('header-component');
    if (!header) return;

    var lastScroll = 0;

    window.addEventListener('scroll', function () {
      var currentScroll = window.pageYOffset;

      if (currentScroll > 50) {
        header.classList.add('tipi-header--scrolled');
      } else {
        header.classList.remove('tipi-header--scrolled');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  // --- Tilt effect on hero tiles (desktop only) ---
  function initTiltEffect() {
    if (window.matchMedia('(hover: none)').matches) return;

    var tiles = document.querySelectorAll('.tipi-home__hero-tile');
    tiles.forEach(function (tile) {
      tile.addEventListener('mouseenter', function () {
        tile.style.transition = 'transform 0.2s ease';
      });

      tile.addEventListener('mousemove', function (e) {
        var rect = tile.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var tiltX = (y - centerY) / centerY * 3;
        var tiltY = (centerX - x) / centerX * 3;
        tile.style.transform = 'perspective(800px) rotateX(' + tiltX + 'deg) rotateY(' + tiltY + 'deg) scale(1.03)';
      });

      tile.addEventListener('mouseleave', function () {
        tile.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
        tile.style.transform = '';
      });
    });
  }

  // --- Init ---
  function init() {
    initScrollReveal();
    addMarquee();
    initHeaderScroll();
    initTiltEffect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
